import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import { Card, Col, Form, Row } from "react-bootstrap";
import "./signupvendor.scss";
import { Nav, Tab, Tabs } from 'react-bootstrap';
import loginBg from "../../assets/images/login-bg.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
//import Slider from "react-slick";
import { Link } from 'react-router-dom';

const Signupvendor = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="login-page">
        <Form>
          <Card className="border-0 border-radius-0">
            <Row className="g-0">
              <Col md={6}>
                <img
                  src={loginBg}
                  alt="PrimeShark"
                  className="img-fluid login-img"
                />
              </Col>
              <Col md={6} className='p-4'>

                {/* Header */}
                <div className="mb-1 d-flex">

                  <button className="btn btn-light rounded-3 mb-3">
                    ←
                  </button>

                  <h4 className="fw-bold">Edit Profile</h4>

                </div>

                <p className="text-muted py-0">Edit your profile details below</p>

                {/* FORM */}
                <div className="row gy-3">

                  {/* Full Name */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Full Name <span className="text-danger">*</span>
                    </label>
                    <input className="form-control " placeholder="Enter your name" />
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Email ID <span className="text-danger">*</span>
                    </label>
                    <input className="form-control " placeholder="Enter Email ID" />
                  </div>

                  {/* Mobile */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input className="form-control " placeholder="Enter mobile number" />
                  </div>

                  {/* About */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      About Me <span className="text-danger">*</span>
                    </label>
                    <input className="form-control " placeholder="Enter information" />
                  </div>

                  {/* Country */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Country <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* City */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      City <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Address */}
                  <div className="col-12">
                    <label className="form-label fw-semibold">Address</label>
                    <input className="form-control " placeholder="Enter full address" />
                  </div>

                  {/* Social */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Social Profiles <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Portfolio */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Portfolio <span className="text-danger">*</span>
                    </label>
                    <input className="form-control " placeholder="Enter URL" />
                  </div>

                  {/* Education */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Education Details</label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Experience */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Professional Experience <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Industry */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Industry Expertise <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Geography */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Geographies <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Market */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Market Focus <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Availability */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Availability Type <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  {/* Charges */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Session Charges <span className="text-danger">*</span>
                    </label>
                    <select className="form-select">
                      <option>Select</option>
                    </select>
                  </div>

                  <div className="col-md-6 d-flex align-items-end">
                    <small className="text-muted">Platform Fees 15%</small>
                  </div>

                </div>


                {/* Save Button */}
                <div className="mt-5">
                  <button className="btn btn-primary w-100 btn btn-primary">
                    Save
                  </button>
                </div>

              </Col>
            </Row>
          </Card>
        </Form>
      </section>
    </>
  );
};

export default Signupvendor;
